import createAPI from '../axios'
//import { config } from 'vue/types/umd';

//排课管理系统相关API
const timetableManageSkillsTraining = {
    //通用
    common: {
        //课表基础参数
        baseParam: config => createAPI('/timetableManageSkillsTraining/common/baseParam', 'post', config),
        //当前学期相关信息
        semesterInfo: config => createAPI('/timetableManageSkillsTraining/common/semesterInfo', 'post', config),
        //周次下拉框
        weekCombo: config => createAPI('/timetableManageSkillsTraining/common/weekCombo', 'post', config),
        //获取单周具体日期
        weekdayDate: config => createAPI('/timetableManageSkillsTraining/common/weekdayDate', 'post', config),
        //查询班级树
        queryClassTree: config => createAPI('/timetableManageSkillsTraining/common/queryClassTree', 'post', config),
        //查询用户排课权限
        queryUserAuth: config => createAPI('/timetableManageSkillsTraining/common/queryUserAuth', 'post', config),
        //根据排课权限查询班级树
        queryClassTreeByAuth: config => createAPI('/timetableManageSkillsTraining/common/queryClassTreeByAuth', 'post', config),
    },

    //教师排课权限设置
    teaAuthConfig: {
        //初始化页面下拉框数据
        initCombo: config => createAPI('/timetableManageSkillsTraining/rule/teaAuthConfig/initCombo', 'post', config),
        //查询教师权限列表
        queList: config => createAPI('/timetableManageSkillsTraining/rule/teaAuthConfig/queList', 'post', config),
        //保存教师权限
        save: config => createAPI('/timetableManageSkillsTraining/rule/teaAuthConfig/save', 'post', config),
        //删除教师权限
        del: config => createAPI('/timetableManageSkillsTraining/rule/teaAuthConfig/del', 'post', config),
    },

    //排课解锁
    unlock: {
        //查询排课锁定列表
        queLockList: config => createAPI('/timetableManageSkillsTraining/unlock/queLockList', 'post', config),
        //解锁
        unlock: config => createAPI('/timetableManageSkillsTraining/unlock/unlock', 'post', config),
    },

    //自定义课程
    customCourse: {
        //查询自定义课程列表
        list: config => createAPI('/timetableManageSkillsTraining/customCourse/list', 'post', config),
        //初始化下拉框
        initCombo: config => createAPI('/timetableManageSkillsTraining/customCourse/initCombo', 'post', config),
        //保存
        save: config => createAPI('/timetableManageSkillsTraining/customCourse/save', 'post', config),
        //删除
        del: config => createAPI('/timetableManageSkillsTraining/customCourse/del', 'post', config),
    },

    //学生设置
    stuSetting: {
        //初始化下拉框
        initCombo: config => createAPI('/timetableManageSkillsTraining/stuSetting/initCombo', 'post', config),
        //读取课程下拉框数据
        loadCourseCombo: config => createAPI('/timetableManageSkillsTraining/stuSetting/loadCourseCombo', 'post', config),
        //读取学生名单列表
        list: config => createAPI('/timetableManageSkillsTraining/stuSetting/list', 'post', config),
        //读取学生树
        queryStuTree: config => createAPI('/timetableManageSkillsTraining/stuSetting/queryStuTree', 'post', config),
        //添加学生
        add: config => createAPI('/timetableManageSkillsTraining/stuSetting/add', 'post', config),
        //删除学生
        del: config => createAPI('/timetableManageSkillsTraining/stuSetting/del', 'post', config),
    },

    //排课
    arrange: {
        //查询学年学期列表
        queSemesterList: config => createAPI('/timetableManageSkillsTraining/arrange/queSemesterList', 'post', config),
        //初始化页面下拉框数据
        initCombo: config => createAPI('/timetableManageSkillsTraining/arrange/initCombo', 'post', config),
        //初始化空白课表
        initTimetable: config => createAPI('/timetableManageSkillsTraining/arrange/initTimetable', 'post', config),
        //读取自动排课下拉框数据
        initCombo4Auto: config => createAPI('/timetableManageSkillsTraining/arrange/initCombo4Auto', 'post', config),
        //读取自动排课系部下拉框数据
        loadDeptCombo4Auto: config => createAPI('/timetableManageSkillsTraining/arrange/loadDeptCombo4Auto', 'post', config),
        //读取自动排课年级下拉框数据
        loadGradeCombo4Auto: config => createAPI('/timetableManageSkillsTraining/arrange/loadGradeCombo4Auto', 'post', config),
        //读取自动排课专业下拉框数据
        loadMajorCombo4Auto: config => createAPI('/timetableManageSkillsTraining/arrange/loadMajorCombo4Auto', 'post', config),
        //读取自动排课班级下拉框数据
        loadClassCombo4Auto: config => createAPI('/timetableManageSkillsTraining/arrange/loadClassCombo4Auto', 'post', config),
        //自动排课
        autoCourseArrange: config => createAPI('/timetableManageSkillsTraining/arrange/autoCourseArrange', 'post', config),
        //读取排课进度
        loadProgress: config => createAPI('/timetableManageSkillsTraining/arrange/loadProgress', 'post', config),
        //读取删除课表系部下拉框数据
        loadDeptCombo4Del: config => createAPI('/timetableManageSkillsTraining/arrange/loadDeptCombo4Del', 'post', config),
        //读取删除课表年级下拉框数据
        loadGradeCombo4Del: config => createAPI('/timetableManageSkillsTraining/arrange/loadGradeCombo4Del', 'post', config),
        //读取删除课表专业下拉框数据
        loadMajorCombo4Del: config => createAPI('/timetableManageSkillsTraining/arrange/loadMajorCombo4Del', 'post', config),
        //读取删除课表班级下拉框数据
        loadClassCombo4Del: config => createAPI('/timetableManageSkillsTraining/arrange/loadClassCombo4Del', 'post', config),
        //初始化批量排课页面下拉框数据
        initCombo4Batch: config => createAPI('/timetableManageSkillsTraining/arrange/initCombo4Batch', 'post', config),
        //读取批量排课课程下拉框数据
        loadCourseCombo4Batch: config => createAPI('/timetableManageSkillsTraining/arrange/loadCourseCombo4Batch', 'post', config),
        //读取批量排课系部下拉框数据
        loadDeptCombo4Batch: config => createAPI('/timetableManageSkillsTraining/arrange/loadDeptCombo4Batch', 'post', config),
        //读取批量排课年级下拉框数据
        loadGradeCombo4Batch: config => createAPI('/timetableManageSkillsTraining/arrange/loadGradeCombo4Batch', 'post', config),
        //读取批量排课专业下拉框数据
        loadMajorCombo4Batch: config => createAPI('/timetableManageSkillsTraining/arrange/loadMajorCombo4Batch', 'post', config),
        //读取批量排课班级下拉框数据
        loadClassCombo4Batch: config => createAPI('/timetableManageSkillsTraining/arrange/loadClassCombo4Batch', 'post', config),
        //查询批量排课班级的排课情况
        queryCourseArrange4Batch: config => createAPI('/timetableManageSkillsTraining/arrange/queryCourseArrange4Batch', 'post', config),
        //保存批量排课信息
        saveCourseArrange4Batch: config => createAPI('/timetableManageSkillsTraining/arrange/saveCourseArrange4Batch', 'post', config),
        //删除课表
        delTimetable: config => createAPI('/timetableManageSkillsTraining/arrange/delTimetable', 'post', config),
        //检查排课锁定状态
        verifyLockState: config => createAPI('/timetableManageSkillsTraining/arrange/verifyLockState', 'post', config),
        //处理排课锁定状态
        handleLockState: config => createAPI('/timetableManageSkillsTraining/arrange/handleLockState', 'post', config),
        //初始化教师场地已用信息
        initUsedOrderInfo: config => createAPI('/timetableManageSkillsTraining/arrange/initUsedOrderInfo', 'post', config),
        //查询教师场地已用信息
        queUsedOrderInfo: config => createAPI('/timetableManageSkillsTraining/arrange/queUsedOrderInfo', 'post', config),
        //查询班级课程安排信息
        queryClassCourseArrangeInfo: config => createAPI('/timetableManageSkillsTraining/arrange/queryClassCourseArrangeInfo', 'post', config),
        //验证排课信息
        verifyCourseArrange: config => createAPI('/timetableManageSkillsTraining/arrange/verifyCourseArrange', 'post', config),
        //保存班级课程表信息
        saveTimetable: config => createAPI('/timetableManageSkillsTraining/arrange/saveTimetable', 'post', config),
        //查询周次使用情况（手动修改课程信息页面调用）
        queWeekUsedInfo: config => createAPI('/timetableManageSkillsTraining/arrange/queWeekUsedInfo', 'post', config),
        //查询教师下拉框（手动修改课程信息页面调用）
        queTeaCombo4Change: config => createAPI('/timetableManageSkillsTraining/arrange/queTeaCombo4Change', 'post', config),
        //查询场地下拉框（手动修改课程信息页面调用）
        queSiteCombo4Change: config => createAPI('/timetableManageSkillsTraining/arrange/queSiteCombo4Change', 'post', config),
        //查询场地下拉框（未排课程指定教室调用）
        queSiteComboByType: config => createAPI('/timetableManageSkillsTraining/arrange/queSiteComboByType', 'post', config),
        //查询备注信息
        queryRemark: config => createAPI('/timetableManageSkillsTraining/arrange/queryRemark', 'post', config),
        //保存备注信息
        saveRemark: config => createAPI('/timetableManageSkillsTraining/arrange/saveRemark', 'post', config),
        //查询学期排课时间列表
        querySemesterTimeList: config => createAPI('/timetableManageSkillsTraining/arrange/querySemesterTimeList', 'post', config),
        //更新排课时间信息
        updateTimeInfo: config => createAPI('/timetableManageSkillsTraining/arrange/updateTimeInfo', 'post', config),
        //查询课表校验信息
        queryTimetableVerifyInfo: config => createAPI('/timetableManageSkillsTraining/arrange/queryTimetableVerifyInfo', 'post', config),
        //导出课表校验信息
        exportTimetableVerifyInfo: config => createAPI('/timetableManageSkillsTraining/arrange/exportTimetableVerifyInfo', 'post', config),
        //查询课程安排情况信息
        queryExecuteInfo: config => createAPI('/timetableManageSkillsTraining/arrange/queryExecuteInfo', 'post', config),
        //导出课程安排情况信息
        exportExecuteInfo: config => createAPI('/timetableManageSkillsTraining/arrange/exportExecuteInfo', 'post', config),
        //更新班级禁排信息
        updateClassForbidInfo: config => createAPI('/timetableManageSkillsTraining/arrange/updateClassForbidInfo', 'post', config),
        //同步开课计划
        syncTeachingPlan: config => createAPI('/timetableManageSkillsTraining/arrange/syncTeachingPlan', 'post', config),
        //检查是否正在进行初始化使用情况操作
        verifyInitUsedOrderState: config => createAPI('/timetableManageSkillsTraining/arrange/verifyInitUsedOrderState', 'post', config),
        //处理调课信息
        handleCourseAdjustInfo: config => createAPI('/timetableManageSkillsTraining/arrange/handleCourseAdjustInfo', 'post', config),
        //验证合班课程排课信息
        verifyMergeCourseArrange: config => createAPI('/timetableManageSkillsTraining/arrange/verifyMergeCourseArrange', 'post', config),
    },

    //查询
    query: {
        //查询教师课表
        tea: config => createAPI('/timetableManageSkillsTraining/query/tea', 'post', config),
        //查询学生课表
        stu: config => createAPI('/timetableManageSkillsTraining/query/stu', 'post', config),
        //查询班级课表
        class: config => createAPI('/timetableManageSkillsTraining/query/class', 'post', config),
        //查询场地课表
        site: config => createAPI('/timetableManageSkillsTraining/query/site', 'post', config),
        //查询课程课表
        course: config => createAPI('/timetableManageSkillsTraining/query/course', 'post', config),

        queryStudent: config => createAPI('/timetableManageSkillsTraining/query/queryStudent', 'post', config),
        stuSearch: config => createAPI('/timetableManageSkillsTraining/query/stuSearch', 'post', config),
        gradeOption: config => createAPI('/timetableManageSkillsTraining/query/gradeOption', 'post', config),
        deptOption: config => createAPI('/timetableManageSkillsTraining/query/deptOption', 'post', config),
        majorOption: config => createAPI('/timetableManageSkillsTraining/query/majorOption', 'post', config),
        classOption: config => createAPI('/timetableManageSkillsTraining/query/classOption', 'post', config),
        stuOption: config => createAPI('/timetableManageSkillsTraining/query/stuOption', 'post', config),
    },

    classTimetable: {
        exportFile: config => createAPI('/timetableManageSkillsTraining/query/classTimetable/exportFile', 'post', config),
        printFile: config => createAPI('/timetableManageSkillsTraining/query/classTimetable/printFile', 'post', config),
        exportAll: config => createAPI('/timetableManageSkillsTraining/query/classTimetable/exportAll', 'post', config),
        initCombo: config => createAPI('/timetableManageSkillsTraining/query/classTimetable/initCombo', 'post', config),
        deleteDocumentFile: config => createAPI('/timetableManageSkillsTraining/query/classTimetable/deleteDocumentFile', 'get', config),
        queryDocumentById: config => createAPI('/timetableManageSkillsTraining/query/classTimetable/queryDocumentById', 'get', config),
        timetableDocumentUpload: config => createAPI('/timetableManageSkillsTraining/query/classTimetable/timetableDocumentUpload', 'post', config),
    },

    teaTimetable: {
        queryTea: config => createAPI('/timetableManageSkillsTraining/query/teaTimetable/queryTea', 'post', config),
        initCombo: config => createAPI('/timetableManageSkillsTraining/query/teaTimetable/initCombo', 'post', config),
        exportFile: config => createAPI('/timetableManageSkillsTraining/query/teaTimetable/exportFile', 'post', config),
        printFile: config => createAPI('/timetableManageSkillsTraining/query/teaTimetable/printFile', 'post', config),
        exportAll: config => createAPI('/timetableManageSkillsTraining/query/teaTimetable/exportAll', 'post', config),
        loadCourse: config => createAPI('/timetableManageSkillsTraining/query/teaTimetable/loadCourse', 'post', config),
        loadStuList: config => createAPI('/timetableManageSkillsTraining/query/teaTimetable/loadStuList', 'post', config),
        exportStuList: config => createAPI('/timetableManageSkillsTraining/query/teaTimetable/exportStuList', 'post', config),
        printStuList: config => createAPI('/timetableManageSkillsTraining/query/teaTimetable/printStuList', 'post', config),
        teaCombo: config => createAPI('/timetableManageSkillsTraining/query/teaTimetable/teaCombo', 'post', config),
        changeDept: config => createAPI('/timetableManageSkillsTraining/query/teaTimetable/changeDept', 'post', config),
    },

    stuTimetable: {
        printFile: config => createAPI('/timetableManageSkillsTraining/query/stuTimetable/printFile', 'post', config),
        exportFile: config => createAPI('/timetableManageSkillsTraining/query/stuTimetable/exportFile', 'post', config),
    },

    siteTimetable: {
        queryTree: config => createAPI('/timetableManageSkillsTraining/query/siteTimetable/queryTree', 'post', config),
        initCombo: config => createAPI('/timetableManageSkillsTraining/query/siteTimetable/initCombo', 'post', config),
        exportFile: config => createAPI('/timetableManageSkillsTraining/query/siteTimetable/exportFile', 'post', config),
        printFile: config => createAPI('/timetableManageSkillsTraining/query/siteTimetable/printFile', 'post', config),
        exportAll: config => createAPI('/timetableManageSkillsTraining/query/siteTimetable/exportAll', 'post', config),
        initComboExport: config => createAPI('/timetableManageSkillsTraining/query/siteTimetable/initComboExport', 'post', config),
        changeSiteType: config => createAPI('/timetableManageSkillsTraining/query/siteTimetable/changeSiteType', 'post', config),
    },

    courseTimetable: {
        queryCourse: config => createAPI('/timetableManageSkillsTraining/query/courseTimetable/queryCourse', 'post', config),
        exportFile: config => createAPI('/timetableManageSkillsTraining/query/courseTimetable/exportFile', 'post', config),
        printFile: config => createAPI('/timetableManageSkillsTraining/query/courseTimetable/printFile', 'post', config),
        exportAll: config => createAPI('/timetableManageSkillsTraining/query/courseTimetable/exportAll', 'post', config),
    },

    allClassTimetable: {
        queryList: config => createAPI('/timetableManageSkillsTraining/query/allClassTimetable/queryList', 'post', config),
        loadAllClassTimetable: config => createAPI('/timetableManageSkillsTraining/query/allClassTimetable/loadAllClassTimetable', 'post', config),
        exportFile: config => createAPI('/timetableManageSkillsTraining/query/allClassTimetable/exportFile', 'post', config),
        print: config => createAPI('/timetableManageSkillsTraining/query/allClassTimetable/print', 'post', config),
    },

    allTeacherTimetable: {
        queryList: config => createAPI('/timetableManageSkillsTraining/query/allTeacherTimetable/queryList', 'post', config),
        loadAllTeaTimetable: config => createAPI('/timetableManageSkillsTraining/query/allTeacherTimetable/loadAllTeaTimetable', 'post', config),
        exportFile: config => createAPI('/timetableManageSkillsTraining/query/allTeacherTimetable/exportFile', 'post', config),
        print: config => createAPI('/timetableManageSkillsTraining/query/allTeacherTimetable/print', 'post', config),
    },

    onlineTimetable: {
        initData: config => createAPI('/timetableManageSkillsTraining/query/onlineTimetable/initData', 'post', config),
        loadWeekNum: config => createAPI('/timetableManageSkillsTraining/query/onlineTimetable/loadWeekNum', 'post', config),
        loadTimetable: config => createAPI('/timetableManageSkillsTraining/query/onlineTimetable/loadTimetable', 'post', config),
        loadSemester: config => createAPI('/timetableManageSkillsTraining/query/onlineTimetable/loadSemester', 'post', config),
        queryWeekdayDate: config => createAPI('/timetableManageSkillsTraining/query/onlineTimetable/queryWeekdayDate', 'post', config),
    },

    courseQuery: {
        initCombo: config => createAPI('/timetableManageSkillsTraining/query/courseQuery/initCombo', 'post', config),
        queryList: config => createAPI('/timetableManageSkillsTraining/query/courseQuery/queryList', 'post', config),
    }
};

export default timetableManageSkillsTraining;



// WEBPACK FOOTER //
// ./src/api/modules/timetableManageSkillsTraining.js